import Dexie from "dexie"
import { useLiveQuery } from "dexie-react-hooks"
import type { SmsMessage } from "@stockline/shared/types/communications/sms-message"
import { offlineDb } from "../../../lib/offline/db"
import { SMS_MESSAGE_TABLE } from "../../../lib/offline/resources/communications/sms-message/db"

const EMPTY: SmsMessage[] = []

/**
 * Reactive read of SMS messages for a single chat, capped at `limit`,
 * ordered **descending** by timestamp (newest → oldest in the array). See
 * useWhatsappMessagesPaged for display-ordering details.
 */
export function useSmsMessagesPaged(
  chatId: string | null,
  limit: number
): SmsMessage[] {
  const result = useLiveQuery(
    async () => {
      if (!chatId) return EMPTY
      const rows = await offlineDb
        .table(SMS_MESSAGE_TABLE)
        .where("[chatId+timestamp]")
        .between([chatId, Dexie.minKey], [chatId, Dexie.maxKey])
        .reverse()
        .limit(limit)
        .toArray()
      return rows as SmsMessage[]
    },
    [chatId, limit],
    EMPTY
  )
  return result ?? EMPTY
}
